import React, { useState } from 'react'
import { supabase } from '../../supabaseClient'
import { useDispatch, useSelector } from 'react-redux'

const AddReply = ({ comment, setShowAddReply, getRepliesArray }) => {
    const [reply, setReply] = useState("")
    const dispatch = useDispatch()
    const isLogged = useSelector(state => state.user.isLoggedIn)
    const currentUser = useSelector(state => state.user.userInfo)

    const handleAddReply = async () => {
        if (!isLogged) {
            dispatch({ type: 'SHOW_AUTH' })
            return
        }
        if (reply.trim().length === 0) {
            alert('Write a reply')
            return
        }

        try {
            // 1. Insert reply into Supabase replies table
            const { error: replyError } = await supabase
                .from('replies')
                .insert([
                    {
                        comment_id: comment.key,
                        user_id: currentUser?.id || 'anonymous',
                        username: currentUser?.username || 'User',
                        text: reply.trim()
                    }
                ])

            if (replyError) throw replyError

            // 2. Increment reply_count in comments table
            const newReplyCount = (comment.reply_count || 0) + 1
            const { error: commentError } = await supabase
                .from('comments')
                .update({ reply_count: newReplyCount })
                .eq('id', comment.key)

            if (commentError) throw commentError

            comment.reply_count = newReplyCount
            alert('Reply added successfully')
            getRepliesArray()
            setShowAddReply(false)

        } catch (error) {
            console.error('Error adding reply:', error.message)
            alert('Failed to add reply')
        }
    }

    const handleHideAddReply = () => {
        setShowAddReply(false)
    }

    const handleChangeReply = (e) => {
        setReply(e.target.value)
    }

    return (
        <div className="flex w-full flex-col mt-2">
            <div className="flex w-full">
                <input 
                    className="w-full ring-2 ring-gray-300 px-2 rounded-md py-1 focus:outline-none focus:ring-blue-500" 
                    onChange={handleChangeReply} 
                    type="text"
                    placeholder="Write a reply..."
                />
            </div>
            <div className="flex w-full">
                <div className="flex w-full justify-end">
                    <button className="m-2 bg-gray-200 px-3 ring-2 ring-gray-300 py-1 text-sm rounded-lg hover:bg-gray-300 transition-colors" onClick={handleAddReply}>Reply</button>
                    <button className="m-2 bg-gray-200 px-3 ring-2 ring-gray-300 py-1 text-sm rounded-lg hover:bg-gray-300 transition-colors" onClick={handleHideAddReply}>Cancel</button>
                </div>
            </div>
        </div>
    )
}

export default AddReply
